// Hooks
import { useEffect, useState, useRef } from 'react';

// GSAP
import { gsap, Power3 } from 'gsap';

// Components
import Pattern from '../Pattern/Pattern';
import TestimonialCard from '../TestimonialCard/TestimonialCard';

const TestimonialsBlock = (props) => {
  const { list } = props;

  const [patternOffset, setPatternOffset] = useState(0);

  const refPattern = useRef();
  const cardRefsObj = [];
  const setRef = (ref) => cardRefsObj.push(ref);

  const setPatternConfig = () => {
    if (cardRefsObj[0]) setPatternOffset(Math.floor(cardRefsObj[0].getBoundingClientRect().height));
  };

  useEffect(() => {
    setPatternConfig();
    const handleResize = () => setTimeout(() => setPatternConfig(), 1000);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const tl = gsap.timeline({ paused: true });

    tl.to(cardRefsObj, {
      duration: 0.5,
      delay: 0.4,
      opacity: 1,
      scale: 1,
      x: 0,
      y: 0,
      stagger: 0.05,
      ease: Power3.easeOut,
    });
    tl.play();

    gsap.to(refPattern.current, { duration: 2, delay: 1, opacity: 1 });
  }, []);

  return (
    <div className="TestimonialsBlock">
      <div className="TestimonialsBlock-pattern" ref={refPattern} style={{ marginTop: `${patternOffset}px` }}>
        <Pattern modifier="Pattern--tolopeaPurple" />
      </div>
      <div className="TestimonialsBlock-inner">
        <div className="TestimonialsBlock-grid">
          {list.map((group, groupIndex) => (
            <div className="TestimonialsBlock-column" key={`TestimonialsBlock--${groupIndex}`}>
              {group.map((card, cardIndex) => (
                <div ref={setRef} className="TestimonialsBlock-card" key={`TestimonialsBlock-card--${cardIndex}`}>
                  <TestimonialCard {...card} />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TestimonialsBlock;
